import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { WatchListResponseInterface } from '@modules/watch-list-module/interfaces/watch-list-response.interface'
import { WatchListHelperService } from '@modules/watch-list-module/services/watch-list-helper.service'
import { catchError, finalize, Observable, of, tap } from 'rxjs'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'
import { UserHelperService } from '@modules/user-module/services/user-helper.service'
import { UserDetailInterface } from '@modules/user-module/interfaces/user-detail.interface'

@Injectable({
	providedIn: 'root',
})
export class WatchListService {
	private readonly _http: HttpClient = inject<HttpClient>(HttpClient)
	private readonly _userHelperService: UserHelperService = inject<UserHelperService>(UserHelperService)
	private readonly _watchListHelperService: WatchListHelperService =
		inject<WatchListHelperService>(WatchListHelperService)
	private readonly _environmentsHelperService: EnvironmentsHelperService =
		inject<EnvironmentsHelperService>(EnvironmentsHelperService)

	public getWatchList(): Observable<WatchListResponseInterface> {
		const userDetail: UserDetailInterface | null = this._userHelperService.userDetail$.getValue()
		if (!userDetail) return of()

		const params: HttpParams = new HttpParams().append('broker_id', userDetail.broker_id)

		if (!this._watchListHelperService.watchList$.getValue()) {
			this._watchListHelperService.isLoadingWatchList$.next(true)
		}
		return this._http
			.get<WatchListResponseInterface>(`${this._environmentsHelperService.apiUrl}/alpaca/get_watchlist/`, {
				params,
			})
			.pipe(
				finalize((): void => {
					this._watchListHelperService.isLoadingWatchList$.next(false)
				}),
				tap((response: WatchListResponseInterface): void => {
					this._watchListHelperService.setWatchList(response)
				}),
				catchError((error: HttpErrorResponse): never => {
					throw error
				}),
			)
	}

	public deleteAsset(symbol: string): Observable<void> {
		return this._http
			.put<void>(`${this._environmentsHelperService.apiUrl}/alpaca/remove_asset_from_watchlist/`, {
				symbol,
			})
			.pipe(
				tap((): void =>
					this._watchListHelperService.watchList$.next(this._watchListHelperService.deleteAsset(symbol)),
				),
			)
	}

	public addAsset(symbol: string): Observable<void> {
		return this._http.put<void>(`${this._environmentsHelperService.apiUrl}/alpaca/add_asset_to_watchlist/`, {
			symbol,
		})
	}
}
